// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle[data-v-595d0c96]{height:auto !important;padding:8px !important}.toggle span>*[data-v-595d0c96]:not(:first-child){margin-left:-8px}.dropdown-content[data-v-595d0c96]{padding:var(--spacing-xs) 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
